import { render, staticRenderFns } from "./SettingsIndexCreate.vue?vue&type=template&id=22d7e844&scoped=true&"
import script from "./SettingsIndexCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexCreate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndexCreate.vue?vue&type=style&index=0&id=22d7e844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7e844",
  null
  
)

export default component.exports